document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.download-content').forEach((root) => {
    const menuItems = Array.from(root.querySelectorAll('.download-menu__links .link-item'));
    const select = root.querySelector('.link-select-menu');
    const tabItems = Array.from(root.querySelectorAll('.download-tab .ef-tab-item'));
    const fileItems = Array.from(root.querySelectorAll('.fileList .fileItem'));

    if (!menuItems.length || !tabItems.length || !fileItems.length) {
      return;
    }

    const getActiveTabDataIndex = () => {
      const activeTab = tabItems.find((tab) => tab.classList.contains('ef-tab-item-active')) || tabItems[0];
      return activeTab ? activeTab.dataset.tabIndex : undefined;
    };

    const getActiveLinkDataIndex = () => {
      const activeLink = menuItems.find((link) => link.classList.contains('link-item-active')) || menuItems[0];
      return activeLink ? activeLink.dataset.index : undefined;
    };

    const setActiveLink = (index, updateSelect = true) => {
      menuItems.forEach((menuItem) => {
        menuItem.classList.toggle('link-item-active', menuItem.dataset.index === index);
      });

      if (select && updateSelect) {
        select.value = index;
      }

      activateFileItemByIndex(index);
    };

    const emptyText = root.querySelector('.emptyText');
    const updateEmptyText = () => {
      if (!emptyText) return;
      const hasActiveItem = root.querySelector('.fileList .fileItem.fileItem-active');
      emptyText.style.display = hasActiveItem ? 'none' : 'block';
    };

    const activateFileItemByIndex = (index) => {
      const activeTabIndex = getActiveTabDataIndex();

      fileItems.forEach((fileItem) => {
        const shouldActivate = fileItem.dataset.index === index && fileItem.dataset.tabIndex === activeTabIndex;
        fileItem.classList.toggle('fileItem-active', shouldActivate);
      });
      updateEmptyText();
    };

    const activateTab = (tabIndex) => {
      const activeLinkIndex = getActiveLinkDataIndex();

      fileItems.forEach((fileItem) => {
        const shouldActivate = fileItem.dataset.tabIndex === tabIndex && fileItem.dataset.index === activeLinkIndex;
        fileItem.classList.toggle('fileItem-active', shouldActivate);
      });
      updateEmptyText();
    };

    menuItems.forEach((item) => {
      item.addEventListener('click', () => {
        setActiveLink(item.dataset.index);
      });
    });

    if (select) {
      select.addEventListener('change', () => {
        setActiveLink(select.value, false);
      });
    }

    const centerActiveTab = (tabItem) => {
      if (!tabItem || !tabItem.scrollIntoView) return;
      tabItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    tabItems.forEach((tabItem) => {
      tabItem.addEventListener('click', () => {
        const tabIndex = tabItem.dataset.tabIndex;

        tabItems.forEach((tab) => {
          tab.classList.remove('ef-tab-item-active');
        });
        tabItem.classList.add('ef-tab-item-active');
        centerActiveTab(tabItem);

        activateTab(tabIndex);
      });
    });

    const searchInput = root.querySelector('.search-input input.ant-input');
    if (searchInput) {
      searchInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') {
          return;
        }

        const query = searchInput.value.trim().toLowerCase();
        if (!query) {
          const activeTabIndex = getActiveTabDataIndex();
          const activeLinkIndex = getActiveLinkDataIndex();

          fileItems.forEach((fileItem) => {
            const shouldActivate = fileItem.dataset.index === activeLinkIndex && fileItem.dataset.tabIndex === activeTabIndex;
            fileItem.classList.toggle('fileItem-active', shouldActivate);
          });
          updateEmptyText();
          return;
        }

        fileItems.forEach((fileItem) => {
          const productName = (fileItem.dataset.productName || '').toLowerCase();
          fileItem.classList.toggle('fileItem-active', productName.includes(query));
        });
        updateEmptyText();
      });
    }

    const activeLinkIndex = getActiveLinkDataIndex();
    if (select && activeLinkIndex !== undefined) {
      select.value = activeLinkIndex;
    }

    const activeTab = tabItems.find((tab) => tab.classList.contains('ef-tab-item-active'));
    if (activeTab) {
      centerActiveTab(activeTab);
    }

    if (!root.querySelector('.fileList .fileItem.fileItem-active')) {
      const firstIndex = menuItems[0]?.dataset.index;
      if (firstIndex !== undefined) {
        activateFileItemByIndex(firstIndex);
      }
    }
    updateEmptyText();
  });
});
